/**
 * Whether the Pronto Assistant panel is open (PA-19).
 *
 * The tour and the panel are two floating layers on the same page: the tour portal is
 * appended by reactour and the panel used to be rendered inside the tree, so whichever
 * mounted later won the stacking order and the tour sat on top of the panel it was
 * pointing at. Two things fix that, and this module is the second half:
 *
 * * the panel is portalled **after `#root`**, so DOM order puts it above the tour;
 * * the tour reads this signal and refuses to advance while the panel is open, so a
 *   popover never steps onto a conversation the user is reading.
 *
 * A body attribute rather than a React context on purpose: the tour lives in a provider
 * above most of the app and the panel is rendered from a different subtree, and a
 * shared DOM signal is the one thing both can observe without threading a provider
 * through every layout.
 */

export const ASSISTANT_PANEL_ATTRIBUTE = 'data-assistant-panel-open';

export const setAssistantPanelOpen = (open: boolean): void => {
  if (typeof document === 'undefined') {
    return;
  }
  if (open) {
    document.body.setAttribute(ASSISTANT_PANEL_ATTRIBUTE, 'true');
  } else {
    document.body.removeAttribute(ASSISTANT_PANEL_ATTRIBUTE);
  }
};

export const isAssistantPanelOpen = (): boolean => {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.body.getAttribute(ASSISTANT_PANEL_ATTRIBUTE) === 'true';
};
